<template>
    <div class="row">
        <div v-for="item in data" :key="item.id" class="col-md-12 mb-4">
            <div class="row">
                <div class="col-md-8">
                    <a :href="item.route"><h3 class="mt-3 mt-md-0 text-dark">{{ item.title }}</h3></a>
                    <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-start">
                        <span class="text-danger font-12">{{ item.category }}</span>
                        &nbsp;
                        <i class="fa fa-circle fa-xs mx-1 d-md-block d-none" style="font-size: 8px; margin-bottom: 3px"></i>
                        &nbsp;
                        <span class="text-muted font-12">Posted on {{ item.published_at }}</span>
                        &nbsp;
                        <i class="fa fa-circle fa-xs mx-1 d-md-block d-none" style="font-size: 8px; margin-bottom: 3px"></i>
                        &nbsp;
                        <span class="text-muted font-12">by {{ item.author }}</span>
                        <!-- <div class="d-inline-block">
                            <a href="" class="font-12 text-dark ml-1">#Wonderfull</a>
                            <a href="" class="font-12 text-dark ml-1">#LoremIpsum</a>
                        </div> -->
                    </div>
                    <p class="mt-3">
                        {{ item.excerpt }}
                        <a :href="item.route">Read more</a>
                    </p>
                </div>
                <div class="col-md-4">
                    <a :href="item.route">
                        <lazy-image :source="item.image"></lazy-image>
                    </a>
                </div>
            </div>
        </div>

        <div class="col-md-12 col-12 col-lg-12 mt-2">
            <div class="overflow-auto">
                <div class="mt-4">
                    <b-pagination
                        v-model="current_page"
                        :total-rows="total"
                        :per-page="per_page"
                        align="center"
                        @input="changePage"
                    >
                    </b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LazyImage from '../../components/LazyImage';
    import FilterPage from '../../components/filters/FilterPage';
    import { BPagination } from 'bootstrap-vue';
    import 'bootstrap-vue/dist/bootstrap-vue.css';

    export default {
        name: 'post-list-content',
        data() {
            return {
                data: [],
                total: 0,
                current_page: 1,
                search: null,
                per_page: 0,
                taxonomy_data: null
            }
        },
        components: {
            LazyImage,
            FilterPage,
            BPagination
        },
        props: {
            taxonomy: {
                required: false
            }
        },
        created() {
            this.taxonomy_data = this.taxonomy ? JSON.parse(this.taxonomy) : null;
            this.handleData();
        },
        methods: {
            async handleData(currentPage) {
                let url = `${baseUrl}/api/post?page=${currentPage}`;
                if(this.taxonomy) {
                    url += `&taxonomy=${this.taxonomy_data.slug}`;
                }

                const result = await axios({
                    method: 'get',
                    url
                });

                this.data = result.data.data.data;
                this.total = result.data.data.total;
                this.per_page = result.data.data.per_page;
            },
            changePage() {
                this.handleData(this.current_page);
                setTimeout(() => {
                    window.scrollTo({
                        top: 330,
                        behavior: 'smooth',
                    });
                }, 100);
            }
        }
    }
</script>
